/**
 * @generated SignedSource<<2f783fbc19aafa3c4cb1d301c979bfcb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type settingsDepartments_department$data = {
  readonly id: string;
  readonly name: string | null;
  readonly sageIntacctId: string | null;
  readonly " $fragmentType": "settingsDepartments_department";
};
export type settingsDepartments_department$key = {
  readonly " $data"?: settingsDepartments_department$data;
  readonly " $fragmentSpreads": FragmentRefs<"settingsDepartments_department">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "settingsDepartments_department",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sageIntacctId",
      "storageKey": null
    }
  ],
  "type": "DepartmentType",
  "abstractKey": null
};

(node as any).hash = "be83e662fd1cf7ee403c326f55b2425e";

export default node;
